<template>
<div>
  <div v-if="!isVehicleDataSet">
      <loader-component />
  </div>
  <div v-else>
    <div>
      <pricing-data :ishidden="!averagePriceAvailable" :pricingDataText="pricingDataText"></pricing-data>
      <pricing-info
        :columnOneLabel="columnOneLabel"
        :columnTwoLabel="columnTwoLabel"
        :columnThreeLabel="columnThreeLabel"
        :columnFourLabel="columnFourLabel"
        :pricingSmallPrint="pricingSmallPrint"
        :noAveragePriceLabel="noAveragePriceLabel"
        :averagePercentSavingLabel="averagePercentSavingLabel"
      ></pricing-info>
    </div>
    </div>
</div>
</template>

<script lang='ts'>
import {
  State, Getter, Action, Mutation, namespace
} from 'vuex-class';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Derivative from '@/models/vehicle/derivative';
import DerivativePricingComponent from './DerivativePricingComponent.vue';
import PricingDataComponent from './PricingDataComponent.vue';
import ThanksTickComponent from '../ui/ThanksTickComponent.vue';
import LoaderComponent from '../ui/LoaderComponent.vue';

const VehicleModule = namespace('vehicleModule');

@Component({
  components: {
  'pricing-info': DerivativePricingComponent,
  'pricing-data': PricingDataComponent,
  'thanks-tick': ThanksTickComponent,
  'loader-component': LoaderComponent
  }
  })
export default class GenericPricingComponent extends Vue {
  @VehicleModule.Getter public averagePriceAvailable;

  @VehicleModule.Getter public isVehicleDataSet;

  @Prop({ default: 'Incredible Price' })
  public columnOneLabel!: string;

  @Prop({ default: 'Great Price' })
  public columnTwoLabel!: string;

  @Prop({ default: 'Good Price' })
  public columnThreeLabel!: string;

  @Prop({ default: 'RRP' })
  public columnFourLabel!: string;

  @Prop({ default: '£' })
  public pricingCurrency!: string;

  @Prop({ default: '*Our great price is based on market research over the last 3 months. This does not represent a quote or offer..' })
  public pricingSmallPrint!: string;

  @Prop({ default: '<span>Here is your Pricing Data</span>' })
  public pricingDataText!: string;

  @Prop({ default: 'We don\'t currently have any discount price data for the exact vehicle you\'ve selected, however we are typically seeing <span>discounts of up to averagePercent on vehicleName cars.</span>  We\'ll now work to get you a great quote.' })
  public averagePercentSavingLabel!: string;

  @Prop({ default: 'We don\'t have specific discount prices for this specific car right now but can help you get an accurate quotation from a local dealership. We’ll ensure someone contacts you shortly to help' })
  public noAveragePriceLabel!: string;
}
</script>
